import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/** Handles the hash-based session_id returned from Emergent Google OAuth for insiders. */
export default function InsiderAuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const done = useRef(false);
  const [status, setStatus] = useState('Signing you in...');

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash;
    const sessionId = hash.includes('session_id=') ? hash.split('session_id=')[1].split('&')[0] : null;
    if (!sessionId) { setStatus('Missing session'); return; }

    const flavor = sessionStorage.getItem('insider_flavor');
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${API}/insider/auth/session`, true);
    xhr.setRequestHeader('X-Session-ID', sessionId);
    if (flavor) xhr.setRequestHeader('X-Flavor', flavor);
    xhr.onload = () => {
      if (xhr.status === 200) {
        const data = JSON.parse(xhr.responseText);
        localStorage.setItem('insider_session_token', data.session_token);
        sessionStorage.removeItem('insider_flavor');
        sessionStorage.removeItem('insider_signup');
        toast.success('Welcome to KBInsider!');
        window.history.replaceState(null, '', '/insider/dashboard');
        navigate('/insider/dashboard', { replace: true });
      } else if (xhr.status === 409) {
        try {
          const err = JSON.parse(xhr.responseText);
          const msg = err.detail?.message || 'Account conflict.';
          setStatus(msg);
          toast.error(msg, { duration: 8000 });
          setTimeout(() => navigate('/kbinsider', { replace: true }), 3000);
        } catch { setStatus('Account conflict'); }
      } else {
        setStatus('Failed to sign in');
      }
    };
    xhr.onerror = () => setStatus('Network error');
    xhr.send();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-white p-6">
      <div className="text-center max-w-md">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-400 mx-auto mb-4"></div>
        <p className="text-white/70">{status}</p>
      </div>
    </div>
  );
}
